/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {ipString} from 'common/yup/customs/ip';
import {enums} from 'types/enums';

export const IPAccessRulesSettingsNames = {
   defaultBehavior: 'defaultBehavior',
   exceptions: 'exceptions',
} as const;

export const ExceptIpNames = {
   access: 'access',
   ip: 'ip',
} as const;

export const ExceptIp = yup.object({
   [ExceptIpNames.ip]: ipString().ensure().required(),
   // [ExceptIpNames.access]: yup.string().oneOf(enums.acessControlBehavior.keys),
});
export type IExceptIp = yup.InferType<typeof ExceptIp>;

export const IPAccessRulesSettings = yup.object({
   [IPAccessRulesSettingsNames.defaultBehavior]: yup
      .string()
      .oneOf(enums.acessControlBehavior.keys)
      .default(enums.acessControlBehavior.enum.ALLOW),
   [IPAccessRulesSettingsNames.exceptions]: yup.array().of(yup.string().ensure()),

   //    [IPAccessRulesSettingsNames.failoverIPs]: yup.array().of(yup.ipString()).ensure(),
});
export type IIPAccessRulesSettings = yup.InferType<typeof IPAccessRulesSettings>;
